import React from "react";

const CopyIcon = ({ size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4081_4688)">
        <path
          d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
          stroke="#777777"
          strokelinecap="round"
          strokelinejoin="round"
        />
        <path
          d="M3.33398 10.0007H2.66732C2.3137 10.0007 1.97456 9.86018 1.72451 9.61013C1.47446 9.36008 1.33398 9.02094 1.33398 8.66732V2.66732C1.33398 2.3137 1.47446 1.97456 1.72451 1.72451C1.97456 1.47446 2.3137 1.33398 2.66732 1.33398H8.66732C9.02094 1.33398 9.36008 1.47446 9.61013 1.72451C9.86018 1.97456 10.0007 2.3137 10.0007 2.66732V3.33398"
          stroke="#777777"
          strokelinecap="round"
          strokelinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4081_4688">
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CopyIcon;
